import { render, staticRenderFns } from "./OrganizationImport.vue?vue&type=template&id=013ce06f&scoped=true"
import script from "./OrganizationImport.vue?vue&type=script&lang=js"
export * from "./OrganizationImport.vue?vue&type=script&lang=js"
import style0 from "./OrganizationImport.vue?vue&type=style&index=0&id=013ce06f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013ce06f",
  null
  
)

export default component.exports